export default __webpack_public_path__ + "static/media/user-dark.2925039d.svg";